import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { GraduationCap } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await register(name, email, password);
      nav("/dashboard");
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid lg:grid-cols-2">
      <div className="hidden lg:flex bg-marino text-white p-12 flex-col justify-between relative overflow-hidden">
        <div className="absolute inset-0 opacity-20"
             style={{ backgroundImage: 'url("https://images.unsplash.com/photo-1773332611514-238856b76198?w=1200")', backgroundSize: 'cover' }} />
        <div className="relative flex items-center gap-3">
          <img src="/shield-ompec.svg" alt="OM-PEC" className="h-14 w-auto" />
          <div>
            <span className="font-heading font-black text-2xl block">OM-PEC</span>
            <span className="text-[10px] uppercase tracking-wider text-naranja font-semibold">Protegemos · Fortalecemos</span>
          </div>
        </div>
        <div className="relative">
          <h2 className="font-heading font-black text-4xl tracking-tight leading-tight">Empieza tu formación</h2>
          <p className="mt-3 text-white/80 max-w-md">Únete a miles de profesionales que se certifican con OM-PEC.</p>
        </div>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-10 bg-white">
        <form onSubmit={submit} className="w-full max-w-md space-y-5">
          <div>
            <h1 className="font-heading font-black text-3xl text-marino tracking-tight">Crear cuenta</h1>
            <p className="mt-1 text-marino/70 text-sm">Registro gratuito como estudiante.</p>
          </div>

          <div>
            <label className="block text-sm font-medium text-marino mb-1">Nombre completo</label>
            <input data-testid="register-name" required value={name} onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-3 border border-gris rounded-lg focus:border-marino focus:outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-marino mb-1">Email</label>
            <input data-testid="register-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 border border-gris rounded-lg focus:border-marino focus:outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-marino mb-1">Contraseña</label>
            <input data-testid="register-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 border border-gris rounded-lg focus:border-marino focus:outline-none" />
          </div>

          {err && <div data-testid="register-error" className="text-naranja text-sm bg-naranja/10 border border-naranja/30 rounded-lg p-3">{err}</div>}

          <button disabled={loading} data-testid="register-submit"
            className="w-full bg-naranja text-white py-3 rounded-lg font-semibold hover:bg-naranjaHover transition-colors disabled:opacity-60">
            {loading ? "Creando cuenta..." : "Registrarme"}
          </button>

          <p className="text-sm text-marino/70 text-center">
            ¿Ya tienes cuenta? <Link to="/login" className="text-naranja font-medium">Iniciar sesión</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
